// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/backendFrontend/wrapImagesForAlignBe.ts

import type { Cheerio, CheerioAPI } from 'cheerio';
import type { Element } from 'domhandler';

// Attributes to keep for diffing images (not part of the mirrored backend file)
const IMG_ATTRS_TO_DIFF = ['src', 'width', 'data-align'];
const stripImgAttrs = ($img: Cheerio<Element>) => {
  const attrs = $img.get(0)?.attribs || {};
  for (const attrName in attrs) {
    if (!IMG_ATTRS_TO_DIFF.includes(attrName)) $img.removeAttr(attrName);
  }
};

export type CheerioElement = Cheerio<Element>;

export const wrapImagesForAlign = ($: CheerioAPI, $root: CheerioElement) => {
  $root.find('img:not([data-complex])').each((_, el) => {
    const $img = $(el);

    // strip all attributes except the ones relevant for diffing
    stripImgAttrs($img);

    // avoid double-wrapping
    if ($img.parent().is('.static-img-container, div.element-row-node')) return;

    // read alignment from data-align or inline style
    const align = $img.attr('data-align')?.toLowerCase();

    const $wrap = $('<div class="static-img-container" />');
    if (align) $wrap.attr('data-align', align); // set alignment on wrapper

    // put the image into the wrapper
    $img.wrap($wrap);
  });
};
